import { useState, useCallback } from 'react'
import { api } from '../../utils'
import { notify } from '../../utils/notify'

export const useFileUpload = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  const upload = useCallback(async (method, url, formData, options = {}) => {
    setLoading(true)
    setError(null)
    setData(null)

    try {
      const response = await api[method](url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...options,
      })

      setData(response.data)

      if (options.onSuccess) {
        options.onSuccess(response.data)
      } else {
        notify('Richiesta inviata con successo.', 'success')
      }

      return response.data
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || err.response?.data || err.message || 'Qualcosa è andato storto.'

      setError(errorMessage)

      if (options.onError) {
        options.onError(errorMessage, err)
      } else {
        notify(errorMessage, 'error')
      }

      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  const reset = useCallback(() => {
    setError(null)
    setData(null)
  }, [])

  return { upload, loading, error, data, reset }
}